
import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Sydney coordinates
const SYDNEY_CENTER = [-33.8688, 151.2093];
/*
// Custom rectangle icon with deviceId label
function deviceRectIcon(label) {
  // Escape HTML for label
  const safeLabel = String(label).replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return new L.DivIcon({
    className: "custom-device-rect-icon",
    html: `<div style="display:inline-flex;align-items:center;">
      <div style="background:#1976d2;color:#fff;font-weight:bold;padding:4px 10px;border-radius:6px;box-shadow:0 2px 6px #0002;font-size:15px;white-space:nowrap;max-width:220px;overflow:hidden;text-overflow:ellipsis;">
        ${safeLabel}
      </div>
    </div>`,
    iconSize: [Math.max(90, 16 * safeLabel.length * 0.7), 36],
    iconAnchor: [45, 18],
    popupAnchor: [0, -18],
  });
}
*/

function deviceRectIcon(label, error) {
  const safeLabel = String(label).replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const led = `<span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:${error ? '#e53935' : '#43a047'};margin-right:7px;box-shadow:0 0 6px ${error ? '#e53935' : '#43a047'}99;"></span>`;
  return new L.DivIcon({
    className: "custom-device-rect-icon",
    html: `<div style="display:inline-flex;align-items:center;">
      ${led}
      <div style="background:#1976d2;color:#fff;font-weight:bold;padding:4px 10px;border-radius:6px;box-shadow:0 2px 6px #0002;font-size:15px;white-space:nowrap;max-width:220px;overflow:hidden;text-overflow:ellipsis;">
        ${safeLabel}
      </div>
    </div>`,
    iconSize: [Math.max(90, 16 * safeLabel.length * 0.7) + 20, 36],
    iconAnchor: [55, 18],
    popupAnchor: [0, -18],
    interactive: true, // <-- add this line
  });
}


function shortAddr(addr) {
  if (!addr || typeof addr !== "string" || addr.length <= 12) return addr || "-";
  return addr.slice(0, 6) + "..." + addr.slice(-6);
}

export default function GeolocationsMap({ devices }) {
  return (
    <div style={{ height: "500px", width: "100%" }}>
      <MapContainer center={SYDNEY_CENTER} zoom={10} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {devices && devices.map((dev, idx) => (
          <Marker
            key={idx}
            position={[dev.latitude, dev.longitude]}
            icon={deviceRectIcon(dev.deviceId || dev.id, dev.error)}
          >
            <Popup> 
              <b>Device:</b> {dev.deviceId || dev.id}<br/>
              <b>User:</b> {shortAddr(dev.user)}<br/>
              <b>Status:</b> {dev.error ? <span style={{color:'#e53935'}}>Error</span> : <span style={{color:'#43a047'}}>OK</span>}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
